import { BaseComponentProps } from "components/typings";
import { ReactNode } from "react";
import { cn } from "utils/ui";
import styles from "./Badge.module.css";

interface Props extends Omit<BaseComponentProps, "dataActionName"> {
  className?: string;
  color?: "default" | "green" | "sky" | "goldfish" | "red" | "amber";
  children?: ReactNode;
}

const Badge = ({ dataTestId, children, className = "", color = "default" }: Props) => {
  return (
    <div className={cn(styles.badge, styles[color], className)} data-test={dataTestId}>
      {children}
    </div>
  );
};

export default Badge;
